import { render, staticRenderFns } from "./ManageUserRolesPage.vue?vue&type=template&id=65fcc718&scoped=true"
import script from "./ManageUserRolesPage.vue?vue&type=script&lang=ts"
export * from "./ManageUserRolesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fcc718",
  null
  
)

export default component.exports